import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
  useLocation,
  useParams,
} from 'react-router-dom';

import {
  StreamApp,
  StatusUpdateForm,
  FlatFeed,
  NotificationDropdown,
  Activity,
  ActivityFooter,
  LikeButton,
  CommentField,
  CommentList,
  CommentItem,
  InfiniteScrollPaginator,
} from 'react-activity-feed';

// import './compiled-all-component-styles.css';
// import './about-app-styles.css';
import '../styles/try-our-own-sass.scss';

import { Tiger21Activity } from '../components/tiger21/Tiger21Activity';

import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

import communityItems from '../data/items.json';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function FeedFromSlug() {
  let query = useQuery();
  const appId: string = query.get('appId') ?? 'handle-value-not-passed';
  const apiKey: string = query.get('apiKey') ?? 'handle-value-not-passed';
  const token: string = query.get('token') ?? 'handle-value-not-passed';
  const feedGroup: string = query.get('feedGroup') ?? 'handle-value-not-passed';
  const feedId: string = query.get('feedId') ?? 'handle-value-not-passed';

  // let { slug } = useParams();

  const getCommunityNameFromSlug = (communitySlug?: string) => {
    let communityName = null;
    communityItems.map((item) => {
      if (item.slug == communitySlug) {
        communityName = item.name;
      }
    });
    if (communityName) {
      return communityName;
    } else {
      // TODO Could not find a matching community name for the slug
      return '';
    }
  };

  // NAME: T21C App - Dev
  // APP ID: 1206230
  // API KEY: p4ryzhnn9944
  // SECRET: <kept separately only on server side>
  // Client side JWT tokens for
  // U--t21c_chair2-1 = eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiVS0tdDIxY19jaGFpcjItMSJ9.JqzSnvsRp4e1r4axdiwTA6Zc9jNLkXgIj5XlwYubtb0
  // U--sumeet_pareek_dev-1 = eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiVS0tc3VtZWV0X3BhcmVla19kZXYtMSJ9.bbPRp5jWy7kdKaqJgmK-YuNuxpH4sUr4rP_LRbZk7Js
  // =========
  // NAME: T21C App - UAT
  // APP ID: 1207176
  // API KEY: 2eufbnqykjuh
  // SECRET: <kept separately only on server side>
  // Client side JWT tokens for
  // U--james_salmon = eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiVS0tamFtZXNfc2FsbW9uIn0.9Zbq_0JfjeqgI1vxSCAItNYe_jQF-71zanMHTi4Cu6E
  // =========
  // NAME: `T21C Stream UAT`, APP ID: `1173466`, KEY: `t478j3apqbjz`
  // User `U--jamessalmon` has Client side JWT token `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiVS0tamFtZXNzYWxtb24ifQ.NJpxC6p2FNPgbA4G_abWEehgJmiXgFCGvpbq8llQ8UE`
  // =========

  return (
    <>
      <div style={{ width: '100%', margin: '0' }}>
        {/* <h1>TEMP re render 0002</h1>
        <h1>appId = {appId}</h1>
        <h1>apiKey = {apiKey}</h1>
        <h1>token = {token}</h1>
        <h1>feedGroup = {feedGroup}</h1>
        <h1>feedId = {feedId}</h1> */}

        <StreamApp appId={appId} apiKey={apiKey} token={token}>
          <FlatFeed
            notify
            feedGroup={feedGroup}
            userId={feedId}
            options={{
              limit: 6,
              withOwnChildren: true,
              withRecentReactions: true,
            }}
            Paginator={InfiniteScrollPaginator}
            Activity={({ activity, feedGroup, userId }) => (
              <Tiger21Activity activity={activity} />
            )}
          />
        </StreamApp>
      </div>
    </>
  );
}
